// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1QkOl","title":"ClientInsurance_title__36r1w","itemText":"ClientInsurance_itemText__2-rcP"};